var _excluded = ["buttonProps", "signUpText"];
var _jsxFileName = "/repo/packages/webassets/src/components/ClientError/SignupButton/index.tsx",
  _this = this;
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { t, defineMessages } from '@sm/intl';
import { Typography } from '@wds/typography';
import { Box } from '@wds/box';
import { Button } from '@wds/button';
import useStyles from './useStyles';
var DEFAULT_COPY = defineMessages({
  SIGN_UP_TEXT: {
    id: 'SignupButton.signUpText',
    defaultMessage: 'Want to create your own survey?',
    description: '[Type: Label][Vis.: med] - Sign up free button description text'
  },
  SIGN_UP_FREE: {
    id: 'SignupButton.signUpFree',
    defaultMessage: 'Sign Up FREE',
    description: '[Type: Label][Vis.: med] - Sign up free button'
  }
});
var DEFAULT_HREF = '/user/sign-up/?ut_source=404_page';
var SignupButton = function SignupButton(_ref) {
  var _buttonProps$label, _buttonProps$href;
  var buttonProps = _ref.buttonProps,
    signUpText = _ref.signUpText,
    containerBoxProps = _objectWithoutProperties(_ref, _excluded);
  var _useStyles = useStyles(),
    container = _useStyles.container;
  var buttonLabel = (_buttonProps$label = buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.label) !== null && _buttonProps$label !== void 0 ? _buttonProps$label : t(DEFAULT_COPY.SIGN_UP_FREE);
  var buttonHref = (_buttonProps$href = buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.href) !== null && _buttonProps$href !== void 0 ? _buttonProps$href : DEFAULT_HREF;
  var description = signUpText !== null && signUpText !== void 0 ? signUpText : t(DEFAULT_COPY.SIGN_UP_TEXT);
  return /*#__PURE__*/React.createElement(Box, Object.assign({}, containerBoxProps, {
    className: container,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 44,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement(Box, {
    mb: 4,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 45,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    component: "div",
    variant: "cardTitle",
    align: "center",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 46,
      columnNumber: 9
    }
  }, description)), /*#__PURE__*/React.createElement(Button, {
    href: buttonHref,
    color: "upgrade",
    size: "lg",
    "data-testid": "ClientError_SignUpButton",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 50,
      columnNumber: 7
    }
  }, buttonLabel));
};
export default SignupButton;
//# sourceMappingURL=index.js.map